import { Link } from "react-router-dom";
import { FileText, Download, ArrowRight } from "lucide-react";
import UseScrollAnimation from "../Elements/ScrollAnimation";

import adultsConsent from "../Assets/pdfs/homeopathic-client-intake-questionnaire.pdf";
import minorConsent from "../Assets/pdfs/minor-client-consent-form-for-homeopathy.pdf";
// import ThreeTestimonials from "./Page_Sections/threeTestimonials";
// import AboutThePractitioner from "./Page_Sections/aboutThePractitioner";

// ✅ Attach files directly here
const forms = [
  {
    title: "Minor Client Consent",
    desc: "Consent form required for clients under 18 years of age.",
    file: minorConsent,
  },
  // {
  //   title: "Adult Client Consent",
  //   desc: "Consent form required for adult clients.",
  //   file: adultsConsent,
  // },
  {
    title: "Client Intake Questionnaire",
    desc: "Initial questionnaire to understand your health history",
    file: adultsConsent,
  },
];

const ClientForms = () => {
  UseScrollAnimation();

  return (
    <>
      <div className="HomeParent">
        <div className="HomeBox ">
          <section className="Disclaimer_Section">
            <div className="Disclaimer_SectionBox">
              <div className="Disclaimer_Section_TitleHeadingContent">
                <p className="Disclaimer_Section_Title animate-top">
                  Client Forms
                </p>
                <span className="Disclaimer_Section_Heading animate-top">
                  Everything you <br />
                  need to begin.
                </span>
                <p className="Disclaimer_Section_Content animate-top">
                  Please complete the relevant forms before your initial
                  consultation. If you have any trouble, just let us know —
                  we're glad to help.
                </p>
              </div>
            </div>
          </section>

          <section className="Disclaimer_Section00">
            <div className="Disclaimer_SectionParent00">
              {forms.map((f) => (
                <span
                  key={f.title}
                  className="Disclaimer_SectionBox02 animate-top"
                >
                  <span className="w-12 h-12 rounded-full bg-secondary flex items-center justify-center shrink-0">
                    <FileText
                      className="Disclaimer_Section_FileTextIcon"
                      strokeWidth={1.5}
                    />
                  </span>

                  <div className="Disclaimer_Section_HeadingContent00">
                    <h3 className="Disclaimer_Section_Heading01">{f.title}</h3>
                    <p className="Disclaimer_Section_Content01">{f.desc}</p>
                  </div>

                  {/* ✅ Download Link */}
                  <a
                    href={f.file}
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                  >
                    <Download className="Disclaimer_Section_Heading01" />
                    <span className="Disclaimer_Section_Content01">
                      Download
                    </span>
                  </a>
                </span>
              ))}

              <div className="Disclaimer_Section_BottomContent animate-top">
                <p className="font-serif text-lg text-foreground">
                  Questions about which form to complete?
                </p>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                  Reach out and we'll guide you through what's needed for your
                  visit.
                </p>

                <div className="Disclaimer_Section_Buttons">
                  <Link
                    to="/contact-us"
                    className="Disclaimer_Section_Button01 animate-top"
                  >
                    <span>Contact us</span>
                    <ArrowRight className="Disclaimer_Section_Button01_ArrowRight" />
                  </Link>
                </div>
              </div>
            </div>
          </section>
          {/* <ThreeTestimonials /> */}

          {/* <AboutThePractitioner /> */}
        </div>
      </div>
    </>
  );
};

export default ClientForms;
